import { render, staticRenderFns } from "./children-monitors.vue?vue&type=template&id=2264d786&"
import script from "./children-monitors.vue?vue&type=script&lang=js&"
export * from "./children-monitors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports